import { type StateCreator } from 'zustand';
import { EnergyType } from "@energy-retailer/constants";

export type CheckboxSliceActions = {
    resetCheckbox: () => void;
    setAvailable: (fuel: EnergyType, available: boolean) => void;
    getChecked: () => CheckboxSliceState;
    setChecked: (fuel: EnergyType, checked: boolean) => void;
};

export type CheckboxSliceState = {
    electricityChecked: boolean;
    electricityAvailable: boolean;
    gasChecked: boolean;
    gasAvailable: boolean;
};

const initialState: CheckboxSliceState = {
    electricityChecked: true,
    gasChecked: true,
    electricityAvailable: true,
    gasAvailable: true,
}

export const CheckboxSlice: StateCreator<
    CheckboxSliceActions & CheckboxSliceState,
    [['zustand/devtools', never]],
    [],
    CheckboxSliceActions & CheckboxSliceState
> = (set, get) => ({
    ...initialState,
    getChecked: () => get(),
    setChecked: (fuel: EnergyType, checked: boolean) => {
        if (fuel === EnergyType.Electricity) {
            set({ electricityChecked: checked }, undefined, 'CheckboxSliceoot/setChecked');
        } else {
            set({ gasChecked: checked }, undefined, 'CheckboxSliceoot/setChecked');
        }
    },
    setAvailable: (fuel: EnergyType, available: boolean) => {
        if (fuel === EnergyType.Electricity) {
            set({ electricityAvailable: available }, undefined, 'CheckboxSlice/setElectricityAvailable');
        } else {
            set({ gasAvailable: available }, undefined, 'CheckboxSlice/setGasAvailable');
        }
    },
    resetCheckbox: () => {
        set(initialState, undefined, 'CheckboxSlice/resetCheckbox');
    }
});
